export const participantesHistoricoMeses = ['Dez', 'Jan', 'Fev', 'Mar', 'Abr', 'Mai'];

export const participantesHistorico = [
  { mes: 'Dez', ativos: 980, total: 1200, novos: 45, churn: 12 },
  { mes: 'Jan', ativos: 1050, total: 1280, novos: 82, churn: 8 },
  { mes: 'Fev', ativos: 1120, total: 1350, novos: 78, churn: 15 },
  { mes: 'Mar', ativos: 1180, total: 1420, novos: 95, churn: 10 },
  { mes: 'Abr', ativos: 1210, total: 1475, novos: 72, churn: 18 },
  { mes: 'Mai', ativos: 1247, total: 1500, novos: 88, churn: 14 },
];

export const receitaHistorico = [
  { mes: 'Dez', receita: 9800, meta: 10000 },
  { mes: 'Jan', receita: 10500, meta: 10000 },
  { mes: 'Fev', receita: 11200, meta: 11000 },
  { mes: 'Mar', receita: 11800, meta: 11000 },
  { mes: 'Abr', receita: 12100, meta: 12000 },
  { mes: 'Mai', receita: 12800, meta: 12000 },
];

export const statusParticipantes = [
  { name: 'Ativos', value: 1247, color: '#059669' },
  { name: 'Inativos', value: 253, color: '#9ca3af' },
];

export const segmentoEmpresas = [
  { name: 'Tecnologia', value: 3 },
  { name: 'Consultoria', value: 2 },
  { name: 'Saúde', value: 1 },
  { name: 'Educação', value: 1 },
  { name: 'Logística', value: 1 },
  { name: 'Software', value: 1 },
];